import { render, staticRenderFns } from "./HomePic.vue?vue&type=template&id=3fefe244&scoped=true&"
import script from "./HomePic.vue?vue&type=script&lang=js&"
export * from "./HomePic.vue?vue&type=script&lang=js&"
import style0 from "./HomePic.vue?vue&type=style&index=0&id=3fefe244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fefe244",
  null
  
)

export default component.exports